import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "kam-form-edit"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Formulier", -1)
const _hoisted_3 = { class: "no-mb" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Aangemaakt op", -1)
const _hoisted_5 = { class: "no-mb" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Laatst bijgewerkt op", -1)
const _hoisted_7 = { class: "no-mb" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Project", -1)
const _hoisted_9 = { class: "no-mb" }
const _hoisted_10 = {
  key: 0,
  class: "required"
}
const _hoisted_11 = {
  key: 0,
  class: "required"
}
const _hoisted_12 = {
  key: 0,
  class: "required"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Getuigen", -1)
const _hoisted_14 = {
  key: 0,
  class: "required"
}
const _hoisted_15 = {
  key: 0,
  class: "required"
}
const _hoisted_16 = {
  key: 0,
  class: "required"
}
const _hoisted_17 = {
  key: 0,
  class: "required"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Detailfoto('s) situatie", -1)
const _hoisted_19 = {
  key: 0,
  class: "required"
}
const _hoisted_20 = {
  key: 0,
  class: "required"
}
const _hoisted_21 = {
  key: 0,
  class: "required"
}
const _hoisted_22 = {
  key: 0,
  class: "required"
}
const _hoisted_23 = {
  key: 0,
  class: "required"
}
const _hoisted_24 = {
  key: 0,
  class: "required"
}
const _hoisted_25 = {
  key: 0,
  class: "required"
}
const _hoisted_26 = {
  key: 0,
  class: "required"
}
const _hoisted_27 = { style: {"display":"block","margin-top":"8px"} }
const _hoisted_28 = {
  key: 0,
  class: "required"
}
const _hoisted_29 = { style: {"display":"block","margin-top":"8px"} }
const _hoisted_30 = {
  key: 0,
  class: "required"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je het formulier wilt versturen naar de KAM-manager?", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Aanpassingen zijn hierna niet meer mogelijk.", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je het formulier wilt afronden?", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Aanpassingen zijn hierna niet meer mogelijk.", -1)

import { useRoute, useRouter } from 'vue-router'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import type { ComputedRef } from 'vue'
import kamStore from '@/stores/kam.ts'
import axios from 'axios'
import { dateTimeOptions } from '@/helpers/globalVariables'
import { KAMFormStatuses, KAMFormStatusLabelColors } from '@/helpers/kamFormStates'
import Uploader from '@/components/Uploader.vue'
import Filelist from '@/components/Filelist.vue'
import { notification } from 'ant-design-vue'
import { authStore } from '@/stores/auth'
import { createDatePickerProxy, filterOptionByLabel, mapPeopleToOptions } from '@/helpers/kamFormUtils'

type PersonOption = { id: number; full_name: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'KAM001-v1',
  emits: ["required-filled"],
  setup(__props, { emit }: { emit: ({(e: 'required-filled', value: boolean): void}), expose: any, slots: any, attrs: any }) {

function normalizePeople (people: Array<{ id: number; name?: string; full_name?: string }> | undefined | null): PersonOption[] {
  return mapPeopleToOptions(people ?? []).map(person => ({ id: Number(person.id), full_name: person.label }))
}



const route = useRoute()
const router = useRouter()

const loading = ref(false)
const saving = ref(false)

const projectLeaders = ref([])
const siteManagersRef = ref([])
const kamManagersRef = ref([])
const constructionWorkersRef = ref([])

const siteManagers = computed(() => {
  const filters = kamStore().kamForm?.filters as { site_managers?: Array<{ id: number; name?: string; full_name?: string; phone?: string }> } | undefined
  if (filters?.site_managers && filters.site_managers.length) {
    return normalizePeople(filters.site_managers)
  }
  return siteManagersRef.value
})

const projectLeadersComputed = computed(() => {
  const filters = kamStore().kamForm?.filters as { project_leaders?: Array<{ id: number; name?: string; full_name?: string }> } | undefined
  if (filters?.project_leaders && filters.project_leaders.length) return normalizePeople(filters.project_leaders)
  return projectLeaders.value
})

const constructionWorkers = computed(() => {
  const filters = kamStore().kamForm?.filters as { construction_workers?: Array<{ id: number; name?: string; full_name?: string }> } | undefined
  if (filters?.construction_workers && filters.construction_workers.length) {
    return normalizePeople(filters.construction_workers)
  }
  return constructionWorkersRef.value
})

const kamManagers = computed(() => kamManagersRef.value)
const formAnswers = computed(() => kamStore().kamForm?.answers ?? {}) as ComputedRef<Record<string, unknown>>
const dateTimeOfIncidentProxy = createDatePickerProxy(formAnswers, 'dateTimeOfIncident', 'YYYY-MM-DD HH:mm:ss')
const notificationDateNLAProxy = createDatePickerProxy(formAnswers, 'notificationDateNLA', 'YYYY-MM-DD')

function ensureAnswersMedia (form: any) {
  if (!form.answers || Array.isArray(form.answers)) form.answers = {}
  if (!form.answers.media || Array.isArray(form.answers.media)) form.answers.media = {}
  return form.answers.media
}

onMounted(() => {
  getKAMForm()
  getSiteManagers()
  getKAMManagers()
  getConstructionWorkers()
})

onBeforeUnmount(() => {
  kamStore().kamForm = null
})

async function getKAMForm () {
  loading.value = true

  try {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/kamForms/${route.params.kamFormId}`)
    const data = response.data.data
    if (Array.isArray(data.answers)) data.answers = {}
    ensureAnswersMedia(data)

    projectLeaders.value = normalizePeople(data.filters?.project_leaders)
    if (data.project?.project_leader?.id && data.project?.project_leader?.name) {
      const leaderOption = normalizePeople([data.project.project_leader])[0]
      if (leaderOption && !projectLeaders.value.some(p => p.id === leaderOption.id)) {
        projectLeaders.value = [leaderOption, ...projectLeaders.value]
      }
    }

    kamStore().kamForm = data
    const form = kamStore().kamForm
    if (form) {
      if (!form.answers.projectManagerId && form.project?.project_leader?.id) {
        form.answers.projectManagerId = Number(form.project.project_leader.id)
      } else if (form.answers.projectManagerId) {
        form.answers.projectManagerId = Number(form.answers.projectManagerId)
      }
    }
  } catch (e) {
    handleError(e)
    router.push({ name: 'KAMForms' })
  } finally {
    loading.value = false
  }
}

async function update (status:number, showNotification = false) {
  if (!kamStore().kamForm) return

  if (status === KAMFormStatuses.Reported && !hasKamManagerSelected.value) {
    notification.warning({
      message: 'KAM-manager ontbreekt',
      description: 'Selecteer eerst een KAM-manager voordat je het formulier verstuurt.',
      duration: 6
    })
    return
  }

  saving.value = true

  const data = {
    ...kamStore().kamForm,
    status: status,
    answers: {
      ...kamStore().kamForm.answers
    }
  }

  try {
    const response = await axios.put(`${process.env.VUE_APP_API_URL}/kamForms/${route.params.kamFormId}`, data)
    const resp = response.data.data
    if (Array.isArray(resp.answers)) resp.answers = {}
    ensureAnswersMedia(resp)
    kamStore().kamForm = resp

    if (showNotification) { notification.success({ message: 'Wijzigingen opgeslagen.', duration: 3 }) }
  } catch {
    if (showNotification) { notification.error({ message: 'Er is iets mis gegaan. Probeer het later nog eens.' }) }
  } finally {
    saving.value = false
  }
}

async function addMedia (key:string, file:File) {
  const formData = new FormData()
  formData.append('position', key)
  formData.append('files', file)

  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_URL}/kamForms/${route.params.kamFormId}/media`,
      formData
    )

    ensureAnswersMedia(kamStore().kamForm)
    kamStore().kamForm.answers.media = response.data.data.media

    notification.success({
      message: 'Afbeelding toegevoegd.',
      description: 'De afbeelding is succesvol toegevoegd.',
      duration: 3
    })
  } catch {
    notification.error({
      message: 'Afbeelding NIET toegevoegd.',
      description: 'Er is iets mis gegaan. Probeer het later nog eens.'
    })
  }
}

function deleteMedia (file:{ id:number }) : void {
  axios.delete(process.env.VUE_APP_API_URL + '/kamForms/' + route.params.kamFormId + '/media/' + file.id).then((r) => {
    ensureAnswersMedia(kamStore().kamForm)
    kamStore().kamForm.answers.media = r.data.data.media
    notification.success({
      message: 'Foto verwijderd.',
      description: 'De foto is succesvol verwijderd.',
      duration: 5
    })
  })
}

function getSiteManagers () : void {
  axios.get(process.env.VUE_APP_API_URL + '/kamForms/' + route.params.kamFormId + '/siteManagers').then((r) => {
    siteManagersRef.value = r.data
  })
}

function getKAMManagers () : void {
  axios.get(process.env.VUE_APP_API_URL + '/kamForms/' + route.params.kamFormId + '/kamManagers').then((r) => {
    kamManagersRef.value = r.data
  })
}

function getConstructionWorkers () : void {
  axios.get(process.env.VUE_APP_API_URL + '/kamForms/' + route.params.kamFormId + '/constructionWorkers').then((r) => {
    constructionWorkersRef.value = r.data
  })
}

function filterUsers (input:string, record:{ id:number, full_name:string }) {
  return filterOptionByLabel(input, { label: record.full_name })
}

function resultOfAccidentChanged () : void {
  if ([5, 6].includes(kamStore().kamForm.answers.resultOfAccident)) {
    kamStore().kamForm.answers.referenceNLA = null
    kamStore().kamForm.answers.notificationDateNLA = null
    kamStore().kamForm.answers.kamManagerId = null
  }
}

function handleError (error:{ response: { status: number } }) {
  if (error.response && error.response.status === 403) {
    notification.warning({
      message: 'U heeft niet de juiste rechten!',
      description: 'U heeft niet de juiste rechten om dit formulier te bekijken.',
      duration: 3
    })
  } else {
    notification.error({
      message: 'Fout tijdens het ophalen van dit formulier!',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.'
    })
  }
}

const editable = computed(() => {
  const kamForm = kamStore().kamForm
  const user = authStore().user

  if (kamForm !== null) {
    const isCreator = user.id === kamForm.created_by_user_id && kamForm.status === 1
    const isProjectLeader = user.roleNames.includes('project_leader') && kamForm.status === 1
    const isQualityManager = user.roleNames.includes('quality_management') && kamForm.status === 2

    return isCreator || isProjectLeader || isQualityManager
  }

  return false
})

const involvedWoononPeople = computed<{ id:number, full_name:string }[]>(() => {
  const involvedWoononPeople:{ id:number, full_name:string }[] = []
  const kamForm = kamStore().kamForm
  const ids:number[] = kamForm?.answers?.woononInvolvedParties ?? []

  if (ids.length) {
    ids.forEach((involvedPartyId:number) => {
      constructionWorkersRef.value.forEach((constructionWorker:{ id:number, full_name:string }) => {
        if (constructionWorker.id === involvedPartyId) {
          involvedWoononPeople.push(constructionWorker)
        }
      })
    })
  }

  return involvedWoononPeople
})

const involvedNonWoononPeople = computed<{ name:string }[]>(() => {
  const involvedNonWoononPeople:{ name:string }[] = []
  const kamForm = kamStore().kamForm
  const list:string[] = kamForm?.answers?.nonWoononInvolvedParties ?? []

  if (list.length) {
    list.forEach((nonWoononInvolvedParty:string) => {
      involvedNonWoononPeople.push({ name: nonWoononInvolvedParty })
    })
  }

  return involvedNonWoononPeople
})

const allRequiredFilled = computed(() => {
  const kamForm = kamStore().kamForm
  const answers = kamForm?.answers ?? {}
  const media = answers.media ?? {}

  const minRequired = !!(
    answers.siteManagerId &&
    answers.projectManagerId &&
    answers.dateTimeOfIncident &&
    answers.incidentDescription &&
    answers.incidentLocation &&
    (media.overviewPhotos?.length ?? 0)
  )

  const involvedPartiesFilled = !!((answers.woononInvolvedParties?.length ?? 0) || (answers.nonWoononInvolvedParties?.length ?? 0))
  const injuriesFilled = !!(((answers.woononInjuredPeople?.length ?? 0) || (answers.nonWoononInjuredPeople?.length ?? 0)) && answers.injuryDescription)
  const materialDamageFilled = !('materialDamage' in answers) || !answers.materialDamage || !!(answers.materialDamageDescription && (media.materialDamagePhotos?.length ?? 0))

  return minRequired && involvedPartiesFilled && (!answers.injuries || injuriesFilled) && materialDamageFilled
})

const hasKamManagerSelected = computed(() => {
  const managerId = kamStore().kamForm?.answers?.kamManagerId
  return managerId !== null && typeof managerId !== 'undefined' && managerId !== ''
})

const resultsOfAccident = ref([
  { label: 'Dagopname', value: 1 },
  { label: 'Ziekenhuisopname', value: 2 },
  { label: 'Blijvend letsel', value: 3 },
  { label: 'Dodelijke afloop', value: 4 },
  { label: 'Nog te bepalen', value: 5 },
  { label: 'Geen van bovenstaande', value: 6 }
])

const requiredFields = [
  'siteManagerId', 'projectManagerId', 'woononInvolvedParties', 'nonWoononInvolvedParties',
  'dateTimeOfIncident', 'incidentDescription', 'incidentLocation', 'overviewPhotos',
  'injuries', 'woononInjuredPeople', 'injuryDescription',
  'materialDamage', 'materialDamageDescription', 'materialDamagePhotos',
  'resultOfAccident', 'referenceNLA', 'notificationDateNLA', 'kamManagerId'
]
function isRequired (key:string) { return requiredFields.includes(key) }

watch(allRequiredFilled, (newVal) => {
  emit('required-filled', newVal)
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (!_unref(kamStore)().loading.item && _unref(kamStore)().kamForm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, { title: "Details" }, {
                  extra: _withCtx(() => [
                    _createVNode(_component_a_tag, {
                      color: _unref(KAMFormStatusLabelColors)[_unref(kamStore)().kamForm.status]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(kamStore)().kamForm.status_label), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { gutter: [16,16] }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(kamStore)().kamForm.form.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createElementVNode("p", _hoisted_5, _toDisplayString(new Date(_unref(kamStore)().kamForm.created_at).toLocaleString('nl-NL', _unref(dateTimeOptions))), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createElementVNode("p", _hoisted_7, _toDisplayString(new Date(_unref(kamStore)().kamForm.updated_at).toLocaleString('nl-NL', _unref(dateTimeOptions))), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(kamStore)().kamForm.project.name) + " (" + _toDisplayString(_unref(kamStore)().kamForm.project.reference) + ")", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Uitvoerder "),
                              (isRequired('siteManagerId'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_select, {
                              "filter-option": filterUsers,
                              "field-names": { label: 'full_name', value: 'id' },
                              options: _unref(siteManagers),
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(kamStore)().kamForm.answers.siteManagerId,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(kamStore)().kamForm.answers.siteManagerId) = $event)),
                              "show-search": "",
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, null, 8, ["options", "disabled", "value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Projectleider "),
                              (isRequired('projectManagerId'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_select, {
                              "filter-option": filterUsers,
                              "field-names": { label: 'full_name', value: 'id' },
                              options: _unref(projectLeadersComputed),
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(kamStore)().kamForm.answers.projectManagerId,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(kamStore)().kamForm.answers.projectManagerId) = $event)),
                              "show-search": "",
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, null, 8, ["options", "disabled", "value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Betrokken partijen "),
                              (isRequired('woononInvolvedParties'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_select, {
                              mode: "multiple",
                              "filter-option": filterUsers,
                              "field-names": { label: 'full_name', value: 'id' },
                              options: _unref(constructionWorkers),
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(kamStore)().kamForm.answers.woononInvolvedParties,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(kamStore)().kamForm.answers.woononInvolvedParties) = $event)),
                              "show-search": "",
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, null, 8, ["options", "disabled", "value"]),
                            _createVNode(_component_a_checkbox, {
                              style: { marginTop: '8px' },
                              disabled: !_unref(editable) || saving.value,
                              checked: _unref(kamStore)().kamForm.answers.nonWoononInvolved,
                              "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_unref(kamStore)().kamForm.answers.nonWoononInvolved) = $event)),
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Één van de betrokken partijen is niet bekend in Woonon")
                              ]),
                              _: 1
                            }, 8, ["disabled", "checked"]),
                            (_unref(kamStore)().kamForm.answers.nonWoononInvolved)
                              ? (_openBlock(), _createBlock(_component_a_select, {
                                  key: 0,
                                  mode: "tags",
                                  style: { marginTop: '8px' },
                                  disabled: !_unref(editable) || saving.value,
                                  value: _unref(kamStore)().kamForm.answers.nonWoononInvolvedParties,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(kamStore)().kamForm.answers.nonWoononInvolvedParties) = $event)),
                                  onChange: _cache[9] || (_cache[9] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                                }, null, 8, ["disabled", "value"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13,
                            _createVNode(_component_a_select, {
                              mode: "multiple",
                              "filter-option": filterUsers,
                              "field-names": { label: 'full_name', value: 'id' },
                              options: _unref(constructionWorkers),
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(kamStore)().kamForm.answers.woononWitnesses,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(kamStore)().kamForm.answers.woononWitnesses) = $event)),
                              "show-search": "",
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, null, 8, ["options", "disabled", "value"]),
                            _createVNode(_component_a_checkbox, {
                              style: { marginTop: '8px' },
                              disabled: !_unref(editable) || saving.value,
                              checked: _unref(kamStore)().kamForm.answers.nonWoononWitnessesInvolved,
                              "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_unref(kamStore)().kamForm.answers.nonWoononWitnessesInvolved) = $event)),
                              onChange: _cache[13] || (_cache[13] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Één van de getuigen is niet bekend in Woonon")
                              ]),
                              _: 1
                            }, 8, ["disabled", "checked"]),
                            (_unref(kamStore)().kamForm.answers.nonWoononWitnessesInvolved)
                              ? (_openBlock(), _createBlock(_component_a_select, {
                                  key: 0,
                                  mode: "tags",
                                  style: { marginTop: '8px' },
                                  disabled: !_unref(editable) || saving.value,
                                  value: _unref(kamStore)().kamForm.answers.nonWoononWitnesses,
                                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(kamStore)().kamForm.answers.nonWoononWitnesses) = $event)),
                                  onChange: _cache[15] || (_cache[15] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                                }, null, 8, ["disabled", "value"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Datum van incident / ongeval "),
                              (isRequired('dateTimeOfIncident'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_date_picker, {
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              format: "DD-MM-YYYY HH:mm",
                              "show-time": true,
                              "minute-step": 5,
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(dateTimeOfIncidentProxy),
                              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_isRef(dateTimeOfIncidentProxy) ? (dateTimeOfIncidentProxy).value = $event : null)),
                              onChange: _cache[17] || (_cache[17] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, null, 8, ["disabled", "value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Wat is er gebeurd? "),
                              (isRequired('incidentDescription'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_textarea, {
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(kamStore)().kamForm.answers.incidentDescription,
                              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(kamStore)().kamForm.answers.incidentDescription) = $event)),
                              onBlur: _cache[19] || (_cache[19] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, null, 8, ["disabled", "value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Waar is het gebeurd? "),
                              (isRequired('incidentLocation'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_textarea, {
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(kamStore)().kamForm.answers.incidentLocation,
                              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_unref(kamStore)().kamForm.answers.incidentLocation) = $event)),
                              onBlur: _cache[21] || (_cache[21] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, null, 8, ["disabled", "value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Overzichtsfoto('s) situatie "),
                              (isRequired('overviewPhotos'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            (_unref(editable))
                              ? (_openBlock(), _createBlock(Uploader, {
                                  key: 0,
                                  "current-count": _unref(kamStore)().kamForm.answers.media?.overviewPhotos?.length ?? 0,
                                  onNewFileUploaded: _cache[22] || (_cache[22] = ($event: any) => (addMedia('overviewPhotos', $event)))
                                }, null, 8, ["current-count"]))
                              : _createCommentVNode("", true),
                            ((_unref(kamStore)().kamForm.answers.media?.overviewPhotos?.length ?? 0) > 0)
                              ? (_openBlock(), _createBlock(Filelist, {
                                  key: 1,
                                  media: _unref(kamStore)().kamForm.answers.media?.overviewPhotos,
                                  "can-delete": _unref(editable),
                                  onDeleteFile: deleteMedia
                                }, null, 8, ["media", "can-delete"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18,
                            (_unref(editable))
                              ? (_openBlock(), _createBlock(Uploader, {
                                  key: 0,
                                  "current-count": _unref(kamStore)().kamForm.answers.media?.detailPhotos?.length ?? 0,
                                  onNewFileUploaded: _cache[23] || (_cache[23] = ($event: any) => (addMedia('detailPhotos', $event)))
                                }, null, 8, ["current-count"]))
                              : _createCommentVNode("", true),
                            ((_unref(kamStore)().kamForm.answers.media?.detailPhotos?.length ?? 0) > 0)
                              ? (_openBlock(), _createBlock(Filelist, {
                                  key: 1,
                                  media: _unref(kamStore)().kamForm.answers.media?.detailPhotos,
                                  "can-delete": _unref(editable),
                                  onDeleteFile: deleteMedia
                                }, null, 8, ["media", "can-delete"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", null, [
                              _createTextVNode("Is er letsel? "),
                              (isRequired('injuries'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              disabled: !_unref(editable) || saving.value,
                              value: _unref(kamStore)().kamForm.answers.injuries,
                              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_unref(kamStore)().kamForm.answers.injuries) = $event)),
                              onChange: _cache[25] || (_cache[25] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: false }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Nee")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: true }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Ja")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled", "value"])
                          ]),
                          _: 1
                        }),
                        (_unref(kamStore)().kamForm.answers.injuries)
                          ? (_openBlock(), _createBlock(_component_a_col, {
                              key: 0,
                              xs: 24,
                              md: 12
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, [
                                  _createTextVNode("Wie heeft er letsel? "),
                                  (isRequired('woononInjuredPeople'))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_a_select, {
                                  mode: "multiple",
                                  "field-names": { label: 'full_name', value: 'id' },
                                  options: _unref(involvedWoononPeople),
                                  disabled: !_unref(editable) || saving.value,
                                  value: _unref(kamStore)().kamForm.answers.woononInjuredPeople,
                                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_unref(kamStore)().kamForm.answers.woononInjuredPeople) = $event)),
                                  "show-search": "",
                                  onChange: _cache[27] || (_cache[27] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                                }, null, 8, ["options", "disabled", "value"]),
                                _createVNode(_component_a_checkbox, {
                                  style: { marginTop: '8px' },
                                  disabled: !_unref(editable),
                                  checked: _unref(kamStore)().kamForm.answers.nonWoononInjured,
                                  "onUpdate:checked": _cache[28] || (_cache[28] = ($event: any) => ((_unref(kamStore)().kamForm.answers.nonWoononInjured) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Één van de personen met letsel is niet bekend in Woonon")
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "checked"]),
                                (_unref(kamStore)().kamForm.answers.nonWoononInjured)
                                  ? (_openBlock(), _createBlock(_component_a_select, {
                                      key: 0,
                                      mode: "multiple",
                                      "field-names": { label: 'name', value: 'name' },
                                      options: _unref(involvedNonWoononPeople),
                                      disabled: !_unref(editable) || saving.value,
                                      style: { marginTop: '8px' },
                                      value: _unref(kamStore)().kamForm.answers.nonWoononInjuredPeople,
                                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_unref(kamStore)().kamForm.answers.nonWoononInjuredPeople) = $event)),
                                      "show-search": "",
                                      onChange: _cache[30] || (_cache[30] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                                    }, null, 8, ["options", "disabled", "value"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(kamStore)().kamForm.answers.injuries)
                          ? (_openBlock(), _createBlock(_component_a_col, {
                              key: 1,
                              span: 24
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, [
                                  _createTextVNode("Wat is het letsel? "),
                                  (isRequired('injuryDescription'))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_a_textarea, {
                                  disabled: !_unref(editable) || saving.value,
                                  value: _unref(kamStore)().kamForm.answers.injuryDescription,
                                  "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_unref(kamStore)().kamForm.answers.injuryDescription) = $event)),
                                  onBlur: _cache[32] || (_cache[32] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                                }, null, 8, ["disabled", "value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(kamStore)().kamForm.answers.hasOwnProperty('materialDamage'))
                          ? (_openBlock(), _createBlock(_component_a_col, {
                              key: 2,
                              span: 24
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, [
                                  _createTextVNode("Is er materiaalschade? "),
                                  (isRequired('materialDamage'))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_a_radio_group, {
                                  "button-style": "solid",
                                  disabled: !_unref(editable) || saving.value,
                                  value: _unref(kamStore)().kamForm.answers.materialDamage,
                                  "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_unref(kamStore)().kamForm.answers.materialDamage) = $event)),
                                  onChange: _cache[34] || (_cache[34] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_radio_button, { value: false }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Nee")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_radio_button, { value: true }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Ja")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(kamStore)().kamForm.answers.hasOwnProperty('materialDamage') && _unref(kamStore)().kamForm.answers.materialDamage)
                          ? (_openBlock(), _createBlock(_component_a_col, {
                              key: 3,
                              span: 24
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, [
                                  _createTextVNode("Omschrijving van materiaalschade "),
                                  (isRequired('materialDamageDescription'))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_a_textarea, {
                                  disabled: !_unref(editable) || saving.value,
                                  value: _unref(kamStore)().kamForm.answers.materialDamageDescription,
                                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_unref(kamStore)().kamForm.answers.materialDamageDescription) = $event)),
                                  onBlur: _cache[36] || (_cache[36] = ($event: any) => (update(_unref(kamStore)().kamForm.status)))
                                }, null, 8, ["disabled", "value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(kamStore)().kamForm.answers.hasOwnProperty('materialDamage') && _unref(kamStore)().kamForm.answers.materialDamage)
                          ? (_openBlock(), _createBlock(_component_a_col, {
                              key: 4,
                              xs: 24,
                              md: 12
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, [
                                  _createTextVNode("Foto('s) materiaalschade "),
                                  (isRequired('materialDamagePhotos'))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                (_unref(editable))
                                  ? (_openBlock(), _createBlock(Uploader, {
                                      key: 0,
                                      "current-count": _unref(kamStore)().kamForm.answers.media?.materialDamagePhotos?.length ?? 0,
                                      onNewFileUploaded: _cache[37] || (_cache[37] = ($event: any) => (addMedia('materialDamagePhotos', $event)))
                                    }, null, 8, ["current-count"]))
                                  : _createCommentVNode("", true),
                                ((_unref(kamStore)().kamForm.answers.media?.materialDamagePhotos?.length ?? 0) > 0)
                                  ? (_openBlock(), _createBlock(Filelist, {
                                      key: 1,
                                      media: _unref(kamStore)().kamForm.answers.media?.materialDamagePhotos,
                                      "can-delete": _unref(editable),
                                      onDeleteFile: deleteMedia
                                    }, null, 8, ["media", "can-delete"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_unref(authStore)().user.roleNames.includes('quality_management'))
                      ? (_openBlock(), _createBlock(_component_a_row, {
                          key: 0,
                          gutter: [16,16],
                          class: "no-mb"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: 24,
                              md: 12
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, [
                                  _createTextVNode("Gevolg van arbeidsongeval "),
                                  (isRequired('resultOfAccident'))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_a_radio_group, {
                                  class: "vertical-radio-group",
                                  options: resultsOfAccident.value,
                                  disabled: !_unref(editable),
                                  value: _unref(kamStore)().kamForm.answers.resultOfAccident,
                                  "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_unref(kamStore)().kamForm.answers.resultOfAccident) = $event)),
                                  onChange: resultOfAccidentChanged
                                }, null, 8, ["options", "disabled", "value"])
                              ]),
                              _: 1
                            }),
                            ([1, 2, 3, 4].includes(_unref(kamStore)().kamForm.answers.resultOfAccident))
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  xs: 24,
                                  md: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("label", null, [
                                      _createTextVNode("Meldingsnummer NLA "),
                                      (isRequired('referenceNLA'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "*"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_a_input, {
                                      type: "text",
                                      disabled: !_unref(editable) || saving.value,
                                      value: _unref(kamStore)().kamForm.answers.referenceNLA,
                                      "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_unref(kamStore)().kamForm.answers.referenceNLA) = $event))
                                    }, null, 8, ["disabled", "value"]),
                                    _createElementVNode("label", _hoisted_27, [
                                      _createTextVNode("Datum van melden bij NLA "),
                                      (isRequired('notificationDateNLA'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "*"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_a_date_picker, {
                                      "value-format": "YYYY-MM-DD",
                                      format: "DD-MM-YYYY",
                                      disabled: !_unref(editable) || saving.value,
                                      value: _unref(notificationDateNLAProxy),
                                      "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => (_isRef(notificationDateNLAProxy) ? (notificationDateNLAProxy).value = $event : null))
                                    }, null, 8, ["disabled", "value"]),
                                    _createElementVNode("label", _hoisted_29, [
                                      _createTextVNode("Contactpersoon intern "),
                                      (isRequired('kamManagerId'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, "*"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_a_select, {
                                      "filter-option": filterUsers,
                                      "field-names": { label: 'full_name', value: 'id' },
                                      options: _unref(kamManagers),
                                      disabled: !_unref(editable) || saving.value,
                                      value: _unref(kamStore)().kamForm.answers.kamManagerId,
                                      "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_unref(kamStore)().kamForm.answers.kamManagerId) = $event)),
                                      "show-search": ""
                                    }, null, 8, ["options", "disabled", "value"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(editable))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_a_divider),
                          (_unref(editable) && _unref(kamStore)().kamForm.status !== _unref(KAMFormStatuses).Closed)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                style: { marginRight: '8px' },
                                disabled: saving.value,
                                onClick: _cache[42] || (_cache[42] = ($event: any) => (update(_unref(kamStore)().kamForm.status, true)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Opslaan")
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true),
                          (_unref(editable) && _unref(kamStore)().kamForm.status === _unref(KAMFormStatuses).Concept)
                            ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                key: 1,
                                placement: "bottomRight",
                                "ok-text": "Ja, versturen",
                                onConfirm: _cache[43] || (_cache[43] = ($event: any) => (update(_unref(KAMFormStatuses).Reported, true)))
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_31,
                                  _hoisted_32
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    disabled: !_unref(allRequiredFilled) || !_unref(hasKamManagerSelected) || saving.value,
                                    style: { marginRight: '8px' }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Versturen naar KAM-manager")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(editable) && _unref(kamStore)().kamForm.status === _unref(KAMFormStatuses).Reported)
                            ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                key: 2,
                                placement: "bottomRight",
                                "ok-text": "Ja, afronden",
                                onConfirm: _cache[44] || (_cache[44] = ($event: any) => (update(_unref(KAMFormStatuses).Closed, true)))
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_33,
                                  _hoisted_34
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    style: { marginRight: '8px' },
                                    disabled: !_unref(allRequiredFilled) || saving.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Formulier afronden")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(_component_a_skeleton, {
        key: 1,
        active: ""
      }))
}
}

})